import { Component, OnInit } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';
import { BatchDto } from '@cradua/data';

@Component({
  selector: 'cradua-batch-container',
  templateUrl: './batch-container.component.html',
  styleUrls: ['./batch-container.component.scss']
})
export class BatchContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  batchs$: Observable<BatchDto[]>;
  loading: boolean;
  isLoadingBatch$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingBatch$ = this.gatwayFacade.isLoadingGateway("Batch");
    this.batchs$ = this.gatwayFacade.loadGateway("Batch");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteBatch(deletedValue: any) {
    this.gatwayFacade.remove("Batch", deletedValue);
  }


// this method control both the create and update

  onSubmitBatch(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Batchs;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllBatch = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllBatch.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllBatch.length > 0) {
    this.gatwayFacade.add('Batch', addAllBatch);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('Batch', allUpdates, ['id']);
  }

   }


}
